import Vue from 'vue';
import store from '@/store';
import UsuarioModel from "@/models/usuario.model";
import {MapActionsSnackbarModule} from "@/store/modules/snackbar/map-actions.snackbar";

class UsuarioService {

    STATUS_OK: number = 200;
    STATUS_FORBIDDEN: number = 403;

    async cadastrar(body: UsuarioModel): Promise<any> {
        await Vue.prototype.$axios.post('users/register', body)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Usuário cadastrado com sucesso!');
                }
            })
            .catch((error: any) => {
                console.error(error.response);
            });
    }

    async atualizar(body: UsuarioModel): Promise<any> {
        await Vue.prototype.$axios.put(`users/${body.id}`, body)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Usuário atualizado com sucesso!');
                }
            })
            .catch((error: any) => {
                if (error.response.status === this.STATUS_FORBIDDEN) {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, "Sem permissão! Alteração não permitida!");
                }
                console.error(error.response);
            });
    }

    async buscarTodos(): Promise<any> {
        return await Vue.prototype.$axios.get('users')
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    const lista: Array<UsuarioModel> = response.data;
                    return lista;
                } else {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Falha inesperada ao carregar a lista de usuários');
                }
            })
            .catch((error: any) => {
                console.error(error.response);
            });
    }

}

export default new UsuarioService();
